import { Link } from "react-router-dom";

export default function Breadcrumb({ title, paths }) {
    return (
        <div className="relative mt-20 py-20 md:py-32 bg-gradient-to-r from-[#855109] to-[#5d3906] text-white shadow-lg bg-cover bg-center bg-no-repeat relative"
            style={{ backgroundImage: "url('/images/home/service-bg.jpg')" }}>

            {/* OVERLAY */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#855109] to-[#5d3906]backdrop-blur-sm"></div>
            {/* bg-[#855109]/50  */}

            <div className="max-w-7xl mx-auto px-6 pt-6">

                {/* PAGE TITLE */}
                <h1 className="text-4xl md:text-5xl font-extrabold drop-shadow-lg font-vollkorn">
                    {title}
                </h1>

                {/* BREADCRUMB BAR */}
                <div className="mt-4 inline-flex items-center bg-white/10 backdrop-blur-lg px-5 py-2 rounded-full border border-white/20 shadow-md">

                    {/* HOME */}
                    <Link
                        to="/"
                        className="hover:text-yellow-300 transition font-medium font-vollkorn"
                    >
                        Home
                    </Link>

                    {paths.map((item, index) => (
                        <div key={index} className="flex items-center">

                            {/* ICON */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-gray-400 mx-3"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>

                            {/* LINK OR LAST ITEM */}
                            {item.link ? (
                                <Link
                                    to={item.link}
                                    className="hover:text-yellow-300 transition font-medium font-vollkorn"
                                >
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="text-yellow-300 font-semibold font-vollkorn">
                                    {item.label}
                                </span>
                            )}
                        </div>
                    ))}

                </div>
            </div>

            {/* BACKGROUND ACCENT CIRCLES */}
            <div className="absolute top-0 right-0 w-[180px] h-[180px] bg-white/10 rounded-full blur-3xl opacity-30"></div>
            <div className="absolute bottom-0 left-0 w-[150px] h-[150px] bg-white/10 rounded-full blur-2xl opacity-30"></div>
        </div>
    );
}
